const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/audit/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import { auditLogsFilterSchema } from '@/features/settings/audit/components/auditLogsFilter';
export const Route = createFileRoute('/(app)/org/$org/settings/audit/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(auditLogsFilterSchema.catch({
    mode: 'all'
  })),
  beforeLoad: requirePermission('edit_organization')
});